"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Services = void 0;
var angular_1 = __importDefault(require("angular"));
var toaster_service_1 = __importDefault(require("./toaster.service"));
var create_student_service_1 = __importDefault(require("./create-student.service"));
var admin_edit_drive_1 = __importDefault(require("./admin-edit-drive"));
var create_order_service_1 = __importDefault(require("./create-order-service"));
exports.Services = angular_1.default
    .module("services")
    .service("CreateStudentService", create_student_service_1.default)
    .service("AdminEditDriveSessionService", admin_edit_drive_1.default)
    .service("CreateOrderService", create_order_service_1.default)
    .service("ToasterService", toaster_service_1.default);
